(() => {
  const finePointer = matchMedia('(hover:hover) and (pointer:fine)').matches;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!finePointer || reduceMotion) return;

  const cursor = document.getElementById('rf-cursor');
  if (!cursor) return;

  const ring = cursor.querySelector('.rf-cursor__ring');
  const dot = cursor.querySelector('.rf-cursor__dot');

  // Mouse + previous (for direction)
  let mx = innerWidth / 2, my = innerHeight / 2;
  let pmx = mx, pmy = my;

  // Ring trails a target behind the cursor
  let rx = mx, ry = my;
  let dx = 1, dy = 0;
  let trailMag = 0;

  // Feel dials
  const RING_EASE = 0.16;
  const TRAIL_BASE = 0;
  const TRAIL_SPEED_FACTOR = 0.45;
  const TRAIL_MAX = 80;
  const TRAIL_RESP = 0.25;

  // Auto-invert
  const CHECK_MS = 80;
  const DARK_LUMA_THRESHOLD = 0.55;
  let lastCheck = 0;

  // Helpers
  const parseRGBA = (str) => {
    const m = str && str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/i);
    return m ? { r: +m[1], g: +m[2], b: +m[3], a: m[4] !== undefined ? +m[4] : 1 } : { r: 0, g: 0, b: 0, a: 0 };
  };
  
  const relLuma = (r, g, b) => {
    const toLin = v => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * toLin(r) + 0.7152 * toLin(g) + 0.0722 * toLin(b);
  };
  
  const getEffectiveBG = (el) => {
    for (let e = el; e && e !== document; e = e.parentElement) {
      const cs = getComputedStyle(e);
      const bg = parseRGBA(cs.backgroundColor);
      if (bg.a > 0.01) return bg;
      if (cs.backgroundImage && cs.backgroundImage !== 'none') {
        const tc = parseRGBA(cs.color);
        if (relLuma(tc.r, tc.g, tc.b) > 0.7) return { r: 0, g: 0, b: 0, a: 1 };
      }
    }
    return { r: 255, g: 255, b: 255, a: 1 };
  };
  
  const anyAncestorForcesInvert = (el) => {
    for (let e = el; e && e !== document.documentElement; e = e.parentElement) {
      if (e.classList?.contains('cursor-invert') || e.getAttribute?.('data-cursor') === 'invert') return true;
    }
    return false;
  };

  // SHOPIFY COLOR SCHEME DETECTION
  const checkColorScheme = (el) => {
    for (let e = el; e && e !== document.documentElement; e = e.parentElement) {
      // Check for Shopify dark color schemes
      if (e.classList?.contains('color-background-2') ||
          e.classList?.contains('color-inverse') ||
          e.classList?.contains('color-accent-1') ||
          e.classList?.contains('color-accent-2') ||
          e.classList?.contains('rf-footer') ||
          e.tagName === 'FOOTER') {
        return true;
      }
    }
    return false;
  };

  // SHOPIFY FIX: Force expansion with direct style manipulation
  function forceExpansion(expand) {
    if (expand) {
      cursor.classList.add('is-hovering');
      ring.style.width = 'var(--cursor-size-hover)';
      ring.style.height = 'var(--cursor-size-hover)';
      ring.style.setProperty('width', '56px', 'important');
      ring.style.setProperty('height', '56px', 'important');
    } else {
      cursor.classList.remove('is-hovering');
      ring.style.width = '';
      ring.style.height = '';
      ring.style.removeProperty('width');
      ring.style.removeProperty('height');
    }
  }

  // DEBUG: Log when hover should happen
  function debugHover(action, element) {
    console.log(`🎯 Cursor ${action}:`, element);
    console.log(`Classes: ${cursor.className}`);
    console.log(`Ring size: ${getComputedStyle(ring).width}`);
  }

  // Main loop
  function tick(now) {
    dot.style.setProperty('--dot-x', `${mx}px`);
    dot.style.setProperty('--dot-y', `${my}px`);

    const vx = mx - pmx, vy = my - pmy;
    const spd = Math.hypot(vx, vy);
    if (spd > 0.001) { dx = vx / spd; dy = vy / spd; }

    const trailTarget = Math.min(TRAIL_BASE + spd * TRAIL_SPEED_FACTOR, TRAIL_MAX);
    trailMag += (trailTarget - trailMag) * TRAIL_RESP;

    const tx = mx - dx * trailMag;
    const ty = my - dy * trailMag;

    rx += (tx - rx) * RING_EASE;
    ry += (ty - ry) * RING_EASE;
    ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;

    // ENHANCED INVERT LOGIC WITH SHOPIFY COLOR SCHEME DETECTION
    if (!now || now - lastCheck > CHECK_MS) {
      lastCheck = now || 0;
      const el = document.elementFromPoint(mx, my);
      if (el) {
        // Check explicit invert classes first
        if (anyAncestorForcesInvert(el)) {
          cursor.classList.add('is-invert');
        }
        // Check for Shopify color schemes (MAIN FIX FOR FOOTER)
        else if (checkColorScheme(el)) {
          cursor.classList.add('is-invert');
          // NUCLEAR OPTION: Force the styles directly as backup
          ring.style.borderColor = '#fff';
          dot.style.backgroundColor = '#fff';
        }
        // Fallback to luminance detection
        else {
          cursor.classList.remove('is-invert');
          // Reset forced styles
          ring.style.borderColor = '';
          dot.style.backgroundColor = '';
          
          const bg = getEffectiveBG(el);
          const l = relLuma(bg.r, bg.g, bg.b);
          if (l < DARK_LUMA_THRESHOLD) {
            cursor.classList.add('is-invert');
          }
        }
      }
    }

    pmx = mx; pmy = my;
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  // Mouse events
  addEventListener('mousemove', (e) => { 
    mx = e.clientX; 
    my = e.clientY; 
    cursor.classList.remove('is-hidden'); 
  });
  addEventListener('mouseenter', () => cursor.classList.remove('is-hidden'));
  addEventListener('mouseleave', () => cursor.classList.add('is-hidden'));
  addEventListener('mousedown', () => cursor.classList.add('is-pressing'));
  addEventListener('mouseup', () => cursor.classList.remove('is-pressing'));

  // SHOPIFY-PROOF HOVER DETECTION
  const HOVERABLE_SELECTORS = [
    'a', 'button', '[role="button"]', 'summary', 
    '.cursor-hover', '[data-cursor-hover]',
    '.btn', '.button',
    '[href]', 'input[type="submit"]', 'input[type="button"]',
    '.product-card', '.card-wrapper',
    '.shopify-payment-button', '.btn--secondary', '.btn--primary'
  ];
  
  let isHovering = false;

  // Aggressive hover detection
  function checkHover(e) {
    const target = e.target;
    const shouldHover = HOVERABLE_SELECTORS.some(selector => {
      try {
        return target.matches(selector) || target.closest(selector);
      } catch (err) {
        return false;
      }
    });

    if (shouldHover && !isHovering) {
      isHovering = true;
      forceExpansion(true);
      debugHover('EXPAND', target);
    } else if (!shouldHover && isHovering) {
      isHovering = false;
      forceExpansion(false);
      debugHover('SHRINK', target);
    }
  }

  // Multiple event listeners for maximum coverage
  ['mouseover', 'mouseenter', 'mousemove'].forEach(eventType => {
    document.addEventListener(eventType, checkHover, { passive: true, capture: true });
  });

  // Fallback: Check every frame if needed
  function continuousHoverCheck() {
    const el = document.elementFromPoint(mx, my);
    if (el) {
      const shouldHover = HOVERABLE_SELECTORS.some(selector => {
        try {
          return el.matches(selector) || el.closest(selector);
        } catch (err) {
          return false;
        }
      });

      if (shouldHover !== isHovering) {
        isHovering = shouldHover;
        forceExpansion(shouldHover);
      }
    }
  }

  // Run hover check every few frames as backup
  setInterval(continuousHoverCheck, 50);

  // Text mode
  const TEXT_SEL = 'input[type="text"], input[type="email"], input[type="search"], input[type="url"], input[type="tel"], input[type="password"], textarea, [contenteditable="true"]';
  document.addEventListener('mouseover', (e) => { 
    if (e.target.closest(TEXT_SEL)) cursor.classList.add('is-text'); 
  });
  document.addEventListener('mouseout', (e) => { 
    if (e.target.closest(TEXT_SEL)) cursor.classList.remove('is-text'); 
  });
  document.addEventListener('focusin', (e) => { 
    if (e.target.matches(TEXT_SEL)) cursor.classList.add('is-text'); 
  });
  document.addEventListener('focusout', (e) => { 
    if (e.target.matches(TEXT_SEL)) cursor.classList.remove('is-text'); 
  });

  // Shopify section reloads
  document.addEventListener('shopify:section:load', () => {
    isHovering = false;
    forceExpansion(false);
  });

  // ENHANCED DEBUG FUNCTION
  window.debugCursor = () => {
    const el = document.elementFromPoint(mx, my);
    console.log('🐛 CURSOR DEBUG:');
    console.log('Current element:', el);
    console.log('Element classes:', el?.className);
    console.log('Is Shopify color scheme:', checkColorScheme(el));
    console.log('Effective background:', getEffectiveBG(el));
    console.log('Should invert:', cursor.classList.contains('is-invert'));
    console.log('Cursor classes:', cursor.className);
    console.log('Ring border color:', getComputedStyle(ring).borderColor);
    console.log('Dot background:', getComputedStyle(dot).backgroundColor);
  };

  // Auto-debug for footer
  console.log('🎯 Cursor script loaded. Type window.debugCursor() to debug.');
  
})();